(function () {
  angular.module('binky.core.analytics-page', ['binky.core.lodash', 'binky.core.src2-migration']);
})();
